import firebase from "firebase/app"
import "firebase/database";

export class FirebaseDatabase {

    static saveUser(user) {
        return firebase.database().ref(`stylight/users/${user.uid}`).set(user);
    }

    static existsUser() {
        return Promise.resolve(false);
    }

    static deleteUser(uid) {
    		if(uid.trim() === '') {
			return;
		}
        return firebase.database().ref(`stylight/users/${uid}`).remove();
    }

    static updateUserFullNameAndGender(uid, fullName, gender) {
        const userRef = firebase.database().ref(`stylight/users/${uid}`);
        return userRef.update({ fullName: fullName, gender: gender });
    }

    static updateUserEmail(uid, email){
        const userRef = firebase.database().ref(`stylight/users/${uid}`);
        return userRef.update({ email: email });
    }

    static createLike(uid, productUuid, like) {
    		if(uid.trim() === '' || uid.trim() === 'undefined' || productUuid.trim() === '' || productUuid.trim() === 'undefined') {
			return;
		}
        const likeRef = firebase.database().ref(`stylight/likes/${uid}`);
        return likeRef.child(productUuid).set(like);
    }

    static getUserLikes(uid) {
        const likeRef = firebase.database().ref(`stylight/likes/${uid}`);

        return likeRef.orderByChild('dateCreated').limitToLast(200).once('value').then(function (snapshot) {
            return snapshot.val();
        });
    }

    static deleteLike(uid, productUuid) {
    		if(uid.trim() === '' || productUuid.trim() === '') {
    			return;
    		}
        return firebase.database().ref(`stylight/likes/${uid}/${productUuid}`).remove();
        
    }
}
